// extracted by mini-css-extract-plugin
export var centerText = "_64-8";
export var container = "_64-0";
export var doughnutContainer = "_64-7";
export var legend = "_64-a";
export var legendItemColorDisplay = "_64-b";
export var legendItemLabel = "_64-d";
export var legendItemValue = "_64-c";
export var lg = "_64-5";
export var maxWidth = "_64-9";
export var md = "_64-4";
export var responsive = "_64-6";
export var sm = "_64-3";
export var xs = "_64-2";
export var xxs = "_64-1";